import React, { useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { post } from "helpers/api_helper";
import { COURIER } from "helpers/url_helper";
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";

const CourierForm = ({cb = () => {}}) => {
    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handelSubmit = async (e) => {
        e.preventDefault();
        
        try{
            // Create JSON payload
            const payload = {
                name: formData.name,
                description: formData.description
            };
            const res = await post(COURIER, payload);
            if(res.success){
                showSuccessAlert('courier created successfully', () => {
                    setFormData({
                        name: '',
                        description: ''
                    });
                });
                cb();
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to create courier');
        }
    };

    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Courier Patners " /> New Courier Patner</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="name">Courier Patner Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="name" 
                                            name="name" 
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder="Courier Patner Name" 
                                            required 
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="description">Description</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="description" name="description" placeholder="Description" required />
                                    </div>
                                </Col>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2 " style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default CourierForm;